import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Edit, BarChart3, GitPullRequest, Users, GitFork, Settings } from 'lucide-react';

const PromptTabs = ({ promptId }) => {
  const location = useLocation();
  
  const tabs = [
    {
      id: 'code',
      label: 'Code',
      icon: Edit,
      path: `/prompts/${promptId}`,
      exact: true
    },
    {
      id: 'logs',
      label: 'Logs',
      icon: BarChart3,
      path: `/prompts/${promptId}/logs`
    },
    {
      id: 'pull-requests',
      label: 'Pull Requests',
      icon: GitPullRequest,
      path: `/prompts/${promptId}/pull-requests`
    },
    {
      id: 'collaborators',
      label: 'Collaborators',
      icon: Users,
      path: `/prompts/${promptId}/collaborators`
    },
    {
      id: 'forks',
      label: 'Forks',
      icon: GitFork,
      path: `/prompts/${promptId}/forks`
    },
    {
      id: 'experiments',
      label: 'Experiments',
      icon: Settings,
      path: `/prompts/${promptId}/experiments`
    }
  ];

  const isActiveTab = (tab) => {
    if (tab.exact) {
      return location.pathname === tab.path;
    }
    return location.pathname.startsWith(tab.path);
  };

  return (
    <div className="border-b border-gray-200">
      <nav className="flex space-x-8">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = isActiveTab(tab);
          
          return (
            <Link
              key={tab.id}
              to={tab.path}
              className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${
                isActive
                  ? 'border-primary-500 text-primary-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <Icon className="h-4 w-4 inline mr-1" />
              {tab.label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default PromptTabs; 